/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Linear_Th5Inputs */

const en_mk_cmp_linear_th5 = /** @type {(inputs: Mk_Cmp_Linear_Th5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI credits are bought separately up front, $10 minimum.`)
};

const id_mk_cmp_linear_th5 = /** @type {(inputs: Mk_Cmp_Linear_Th5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kredit AI dibeli terpisah di muka, minimum $10.`)
};

/**
* | output |
* | --- |
* | "AI credits are bought separately up front, $10 minimum." |
*
* @param {Mk_Cmp_Linear_Th5Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_linear_th5 = /** @type {((inputs?: Mk_Cmp_Linear_Th5Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Linear_Th5Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_linear_th5(inputs)
	return en_mk_cmp_linear_th5(inputs)
});